import { Divider, List } from "@mui/material";
import type { Document, Signature } from "@ssf/sign-worker";
import { Fragment } from "react";

import { SignatureItem } from "./index.js";

export const SignatureList = ({
  document,
  approved,
}: {
  document: Document & { signatures: Signature[] };
  approved?: boolean;
}) => {
  const signers =
    document.type === "document"
      ? document.meta.signers.map((signer) => ({
          ...signer,
          signature: document.signatures.find(
            ({ email }) => email === signer.email,
          ),
        }))
      : document.signatures.map((signature) => ({
          name: document.meta.member.name,
          signature,
        }));

  return (
    <List dense disablePadding>
      {signers.map((signer, index) => (
        <Fragment key={index.toString()}>
          {!!index && <Divider />}
          <SignatureItem
            document={document}
            documentApproved={approved}
            {...signer}
            open={signers.length === 1}
          />
        </Fragment>
      ))}
    </List>
  );
};
